import { render, staticRenderFns } from "./SIPRoutes.vue?vue&type=template&id=4765070e"
import script from "./SIPRoutes.vue?vue&type=script&lang=ts"
export * from "./SIPRoutes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports